import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.NOTE_PHRASE_SET_NOTE_PHRASE_LIST]: (state, payload) => {
    state.notePhraseList = payload.notePhraseList

    const sortNumberList = payload.notePhraseList.map((ele) => {
      return ele.sortNumber
    })

    if (sortNumberList.length) {
      state.maxSortNumber = Math.max(...sortNumberList)
    }
  }
}

export default Mutations
